import * as React from "react";
import { getStoredAppointment } from "../../../../../../../utils/v3/utils/book-appointment-storage.js";
import useVirtualAppointment from "../../../../../hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
import { useRoutingContext } from "../../../../RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { fromArrayToString } from "../../../../../../../utils/v3/utils/from-array-to-string.js";
const defaultState = {
  store: null,
  type: null,
  timeSlot: null,
  appointment: null
};
const useAppointmentState = (initialState = defaultState) => {
  const [state, dispatch] = React.useReducer((state2, action) => {
    switch (action.type) {
      case "book-appointment/set-store":
        return { ...state2, store: action.payload };
      case "book-appointment/set-type":
        return { ...state2, type: action.payload };
      case "book-appointment/set-time-slot":
        return { ...state2, timeSlot: action.payload };
      case "book-appointment/set-appointment":
        return { ...state2, appointment: action.payload };
      default:
        return state2;
    }
  }, initialState);
  const setStore = React.useCallback(
    (store) => {
      if (state.store !== store) {
        dispatch({ type: "book-appointment/set-store", payload: store });
      }
    },
    [state]
  );
  const setType = React.useCallback(
    (type) => {
      if (state.type !== type) {
        dispatch({ type: "book-appointment/set-type", payload: type });
      }
    },
    [state]
  );
  const setTimeSlot = React.useCallback(
    (timeSlot) => dispatch({ type: "book-appointment/set-time-slot", payload: timeSlot }),
    []
  );
  const setAppointment = React.useCallback(
    (appointment) => dispatch({ type: "book-appointment/set-appointment", payload: appointment }),
    []
  );
  return React.useMemo(
    () => [{ setStore, setType, setTimeSlot, setAppointment }, state],
    [state, setStore, setType, setTimeSlot, setAppointment]
  );
};
const appointmentContext = React.createContext(
  null
);
const AppointmentContextProvider = ({
  children,
  initialState
} = {}) => {
  const { Provider } = appointmentContext;
  const initialStore = initialState?.store ?? defaultState.store;
  const initialType = initialState?.type ?? defaultState.type;
  const initialTimeSlot = initialState?.timeSlot ? {
    from: new Date(parseInt(initialState.timeSlot.from, 10)),
    until: new Date(parseInt(initialState.timeSlot.until, 10))
  } : defaultState.timeSlot;
  const [, { queryParams }] = useRoutingContext();
  const appointmentId = fromArrayToString(queryParams.appointmentId);
  const initialAppointment = getStoredAppointment(appointmentId) ?? null;
  const [
    {
      isVirtualAppointmentStoreById,
      isVirtualAppointmentType,
      getStoreByIdData,
      getAppointmentTypeData
    }
  ] = useVirtualAppointment();
  const type = isVirtualAppointmentType(initialType) ? getAppointmentTypeData(initialType) : initialType;
  const store = isVirtualAppointmentStoreById(initialStore) ? getStoreByIdData(initialStore, type) : initialStore;
  const value = useAppointmentState({
    ...defaultState,
    store,
    type,
    timeSlot: initialTimeSlot,
    appointment: initialAppointment,
    tryInStoreProductSkus: initialState?.tryInStoreProductSkus
  });
  return /* @__PURE__ */ React.createElement(Provider, { value }, children);
};
const useAppointmentContext = () => React.useContext(appointmentContext);
export {
  AppointmentContextProvider,
  appointmentContext,
  defaultState,
  useAppointmentContext
};
//# sourceMappingURL=AppointmentContext.js.map
